import React, { Suspense } from "react";
import { Canvas } from "react-three-fiber";

import img01 from "assets/imgs/1.jpg";
import img02 from "assets/imgs/2.jpg";
import refractImg from "assets/room3.jpg";

import Scene from "components/Scene";

function App() {
  return (
    <Canvas camera={{ zoom: 100 }} orthographic>
      <Suspense fallback="">
        <Scene images={[img01, img02]} refractImg={refractImg} />
      </Suspense>
    </Canvas>
  );
}

export default App;
